import { render } from "./CrearInforme.vue?vue&type=template&id=18f00fec"
import script from "./CrearInforme.vue?vue&type=script&lang=js"
export * from "./CrearInforme.vue?vue&type=script&lang=js"

import "./CrearInforme.vue?vue&type=style&index=0&id=18f00fec&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__